import { render, staticRenderFns } from "./StudentEdition.vue?vue&type=template&id=1cb26776&"
import script from "./StudentEdition.vue?vue&type=script&lang=js&"
export * from "./StudentEdition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports